<template>
  <div class="px-4">
    <div class="header">
      <h1>問卷派發</h1>
      <div class="d-flex align-items-center col-9 justify-content-end"></div>
    </div>
    <div class="filter">
      <div class="d-flex">
        <div class="col-2 d-flex">
          <CFormSelect
            v-model="userListQuery.status"
            class="filter-selector me-3 rounded-pill"
          >
            <option
              :selected="
                userListQuery.status ==
                $defines.QuestionnaireDeliverUserList_Status_All
              "
              :value="$defines.QuestionnaireDeliverUserList_Status_All"
            >
              狀態：全部
            </option>
            <option
              :selected="
                userListQuery.status ==
                $defines.QuestionnaireDeliverUserList_Status_Available
              "
              :value="$defines.QuestionnaireDeliverUserList_Status_Available"
            >
              狀態：可派發
            </option>
          </CFormSelect>
        </div>
        <div class="position-relative d-flex align-items-center col-4">
          <CFormInput
            class="rounded-pill pe-5"
            type="text"
            placeholder="請輸入用户ID、名稱"
            v-model="userListQuery.user_search"
          />
          <!-- <img
            class="position-absolute search"
            src="@/assets/icons/search.svg"
          /> -->
        </div>
      </div>
    </div>
    <div class="py-4 item-wrapper">
      <div class="item wait-list">
        <div class="list-header">
          <p class="title">點擊需發送的用戶</p>
          <p class="choose-all" @click="chooseAll">全選</p>
        </div>
        <div class="user-list">
          <div v-for="user of userList" :key="user.id" class="user-item">
            <div
              class="user-name"
              :class="{
                'is-choose': isChoose(user.id),
                'is-not-available': isNotAvailable(user),
              }"
            >
              <p class="cop-name">{{ user.company_name }}</p>
              <p class="que-name">{{ user.questionnaire_info.title }}</p>
            </div>
            <img
              src="@/assets/icons/add.svg"
              class="add-img"
              alt="add"
              :class="{ 'is-hide': isChoose(user.id) || isNotAvailable(user) }"
              @click="moveUser('add', user)"
            />
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pagination.totalCount"
            :page-size="pagination.pageSize"
            @current-change="pageChange"
          />
        </div>
      </div>
      <img
        class="cross-icon"
        src="@/assets/icons/cross-arrow.svg"
        alt="change"
      />
      <div class="item choose-list">
        <div class="list-header">
          <p class="title">備選用戶列表({{ chooseList.length }})</p>
          <p class="choose-all" @click="reset">清空</p>
        </div>
        <div class="user-list">
          <div v-for="choose of chooseList" :key="choose.id" class="user-item">
            <div class="user-choose">
              <p class="choose-cop-name">{{ choose.company_name }}</p>
            </div>
            <img
              src="@/assets/icons/minus.svg"
              class="add-img"
              alt="add"
              @click="moveUser('remove', choose)"
            />
          </div>
        </div>
      </div>
    </div>
    <button class="save-button" @click="submit">儲存</button>
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>

<script setup>
import MsgBox from '@/components/MsgBox.vue'
import { onMounted, ref, watch } from 'vue'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'
import { QuestionnaireDeliverUserList_Status_All } from '@/defines'
import useQuestionnaire from '@/composables/useQuestionnaire'
import { useRoute } from 'vue-router/dist/vue-router'

const route = useRoute()
const {
  questionnaireDeliverList,
  questionnaireDeliver,
  questionnaireDeliverUserList,
} = useQuestionnaire()
const showMsgBox = ref(false)
const errorMsg = ref('')
const errorCode = ref('')
const pagination = ref({
  currentPage: 1,
  pageSize: 20,
})
const questionnaire_id = route.params.id
const initUserListQueryData = {
  status: QuestionnaireDeliverUserList_Status_All,
  page: 1,
  user_search: '',
}
const userListQuery = ref(initUserListQueryData)
let userListQueryTimer = null
watch(
  () => JSON.stringify(userListQuery.value),
  async () => {
    if (userListQueryTimer) {
      clearTimeout(userListQueryTimer)
    }
    userListQueryTimer = setTimeout(() => {
      loadUserList()
    }, 500)
  },
)

const userList = ref([])
const chooseList = ref([])
const deleteList = ref([])
onMounted(async () => {
  await initUserList()
})
const pageChange = async (page) => {
  userListQuery.value.page = page
}

const isNotAvailable = (user) => {
  if (user.questionnaire_info.id == route.params.id) {
    return false
  }
  return !user.is_available
}

const initUserList = async () => {
  manualToggleLoading(true)
  await loadUserList()
  await initChooseList()
  manualToggleLoading(false)
}
const moveUser = (method, user) => {
  if (method === 'remove') {
    const index = chooseList.value.findIndex((e) => e.id == user.id)
    const info = chooseList.value[index]
    if (info.questionnaire_info.id == route.params.id) {
      deleteList.value.push(chooseList.value[index])
    }
    chooseList.value.splice(index, 1)
  } else {
    const deleteIndex = deleteList.value.findIndex((e) => e.id == user.id)
    if (deleteIndex >= 0) {
      deleteList.value.splice(deleteIndex, 1)
    }

    chooseList.value.push(user)
  }
}

const chooseAll = () => {
  for (const item of userList.value) {
    if (!item.is_available) {
      if (item.questionnaire_info.id != route.params.id) {
        continue
      }
    }
    const has = chooseList.value.find((e) => e.id == item.id)
    if (!has) {
      moveUser('add', item)
    }
  }
}
const reset = () => {
  const items = JSON.parse(JSON.stringify(chooseList.value))
  for (const chooseItem of items) {
    moveUser('remove', chooseItem)
  }
}

const initChooseList = async () => {
  const res = await questionnaireDeliverUserList({
    id: route.params.id,
  })
  if (res.error) {
    showMsgBox.value = true
    errorMsg.value = res.msg
    errorCode.value = res.error
    return
  }
  chooseList.value = res.ret.user_list
}

let submiting = false
const submit = async () => {
  if (submiting) return

  // if (chooseList.value.length == 0) {
  //   return;
  // }
  if (!confirm('是否確認派發')) {
    return false
  }
  submiting = true
  manualToggleLoading(true)
  const res = await questionnaireDeliver({
    questionnaire_id: questionnaire_id,
    user_ids: chooseList.value.map((item) => parseInt(item.id)),
    delete_user_ids: deleteList.value.map((item) => parseInt(item.id)),
  })
  if (res.error) {
    showMsgBox.value = true
    errorMsg.value = res.msg
    errorCode.value = res.error
  } else {
    showMsgBox.value = true
    errorMsg.value = '派發成功'
    location.reload()
  }
  submiting = false
  manualToggleLoading(false)
}
const loadUserList = async () => {
  pagination.value.currentPage = userListQuery.value.page
  const res = await questionnaireDeliverList(userListQuery.value)
  if (res.error) {
    showMsgBox.value = true
    errorMsg.value = res.msg
    errorCode.value = res.error
  } else {
    userList.value = res.ret.data
    pagination.value = res.ret.pagination
  }
  const el = document.querySelector('.user-list')
  el.scrollTo(0, 0)
}

const isChoose = (id) => {
  const index = chooseList.value.find((e) => e.id == id)
  return !!index
}
</script>

<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}

h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}

h3 {
  font-size: 22px;
  margin: 0 20px 0;
}

.filter {
  margin-top: 50px;
}

.search {
  right: 16px;
}

.item-wrapper {
  display: flex;
  justify-content: space-between;

  .item {
    height: calc(100vh - 380px);
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgb(227, 226, 226);

    .list-header {
      background-color: rgb(69, 69, 69);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      line-height: 40px;

      p {
        margin: 0;
        font-size: 15px;
      }

      .choose-all {
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;
      }
    }

    .user-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      border-bottom: 1px solid rgb(227, 226, 226);

      p {
        margin: 0;
      }

      .user-name {
        display: flex;
        align-items: center;
        gap: 20px;
        font-size: 15px;
        width: 100%;

        .cop-name {
          width: 25%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .que-name {
          width: 70%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .user-choose {
        font-size: 15px;
        width: 85%;
        .choose-cop-name {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .add-img {
        width: 1rem;
        cursor: pointer;
      }
    }
  }

  .cross-icon {
    margin: 0 20px;
  }

  .wait-list {
    flex: 1;

    .user-list {
      height: calc(100% - 110px);
      overflow-y: scroll;
      scroll-behavior: smooth;
    }

    .pagination {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .choose-list {
    flex: 0.8;

    .user-list {
      height: calc(100% - 40px);
      overflow-y: scroll;
    }
  }
}

.save-button {
  background-color: #177baf;
  color: rgba(255, 255, 255, 0.9);
  border: none;
  margin: 40px auto 30px auto;
  display: block;
  font-size: 20px;
  width: 160px;
  line-height: 40px;
  border-radius: 8px;
}

.is-choose {
  color: rgb(198, 198, 198);
}

.is-not-available {
  color: rgb(198, 198, 198);
  text-decoration: line-through;
}

.is-hide {
  display: none;
}
</style>
